// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/applications.scss
// module id = 354
// module chunks = 2